export default "__VITE_ASSET__BplAmSvE__"